<template>
  <div v-if="$currentApp" class="actions-value-wrapper">
    <UiSwitch
      id="enableGpayActivation"
      ref="toggleSwitcher"
      :title="toggleSwitcherTitle"
      :is-checked-initial="!isActivationDisabled"
      @input="gPayActionClicked"
    />
  </div>
</template>

<script>
import UiSwitch from '@/components/UiSwitch.vue';
import currentApplicationMixin from '../mixins/currentApplicationMixin'

import { enableGpayActivation, disableGpayActivation } from './GpayActionsMethods.js'

export default {
  components: {
    UiSwitch
  },
  mixins: [currentApplicationMixin],
  computed: {
    isActivationDisabled() {
      return this.$currentApp && this.$currentApp.prohibited_activities === 1
    },
    actionsHelper() {
      return this.isActivationDisabled
        ? {
            action: 'enableGpayActivation',
            buttonText: 'Разрешить активацию Google Pay',
            status: 'Разрешить',
          }
        : {
            action: 'disableGpayActivation',
            buttonText: 'Запретить активацию Google Pay',
            status: 'Запретить',
          }
    },
    toggleSwitcherTitle() {
      return this.actionsHelper.buttonText;
    }
  },
  methods: {
    async gPayActionClicked(action) {
      /** {object} `actionsHashes` Object contains all actions */
      const actionsHashes = { enableGpayActivation, disableGpayActivation }

      const result = await actionsHashes[this.actionsHelper.action].call(this)

      if (!result.isConfirmed) {
        this.$refs.toggleSwitcher.resetSwitcher();
      }

      if (result.isConfirmed && result.value) {
        this.setGpayActivationStatus(Number(result.value.data.data.prohibited_activities));
      }
    },

    /**
     * Update Google Pay activation status without backend request.
     */
    setGpayActivationStatus(value) {
      if (value !== 0 && value !== 1) return

      this.$store.commit('application/SET_CURRENT_APPLICATION', {
        ...this.$currentApp,
        prohibited_activities: value,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.actions-value-wrapper {
  @include createFlex(flexbox, nowrap, row, flex-end, stretch, center);

  .action-icon {
    display: inline-block;
    margin: 0 0 0 rem(8px);
    cursor: pointer;
  }
}

.actions-value-text {
  margin-right: 12px;
}
</style>
